module.exports = __webpack_public_path__ + "ed96749885bb55c3d2dfcfefe0727591.png";